import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background" data-testid="privacy-page">
      <div className="max-w-[760px] mx-auto px-6 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-1">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Ami Video Crew &middot; Last updated: June 2026</p>

        <p className="text-base leading-relaxed mb-8">
          Ami Video Crew ("the App") is a crew scheduling and production management tool operated by
          Ami Video ("we", "us"). This policy explains what information we collect and how we use it.
        </p>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Information We Collect</h2>
        <ul className="list-disc pl-5 space-y-2 text-base leading-relaxed">
          <li><strong>Account information</strong> — name, email address, phone number, and role, provided when your studio administrator creates your account.</li>
          <li><strong>Scheduling &amp; work data</strong> — event assignments, availability, blocked dates, payment records, and project details you or your administrator enter.</li>
          <li><strong>Photos</strong> — reference images you choose to upload (e.g. for shot lists). Access to your camera or photo library is only used when you initiate an upload.</li>
          <li><strong>Location</strong> — used only if you choose to confirm arrival at an event venue. We do not track your location in the background.</li>
        </ul>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">How We Use Your Information</h2>
        <ul className="list-disc pl-5 space-y-2 text-base leading-relaxed">
          <li>To provide scheduling, assignment, payment tracking, and workflow features.</li>
          <li>To send you notifications about your assignments and schedule changes via email or SMS.</li>
          <li>To operate, maintain, and improve the App.</li>
        </ul>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Data Sharing</h2>
        <p className="text-base leading-relaxed">
          We do not sell your personal information. Data is shared only with service providers that help us
          operate the App (such as email and hosting providers) and only as needed to deliver these services.
        </p>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Data Security &amp; Retention</h2>
        <p className="text-base leading-relaxed">
          Your data is stored securely and retained for as long as your account is active or as needed to
          provide the service. You may request deletion of your account and associated data at any time.
        </p>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Your Rights</h2>
        <p className="text-base leading-relaxed">
          You can request access to, correction of, or deletion of your personal information by contacting us
          at the address below.
        </p>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Children's Privacy</h2>
        <p className="text-base leading-relaxed">
          The App is intended for use by professional crew members and is not directed at children under 13.
        </p>

        <h2 className="text-xl font-semibold tracking-tight mt-8 mb-3">Contact Us</h2>
        <p className="text-base leading-relaxed">
          If you have any questions about this Privacy Policy, contact us at:<br />
          <a href="mailto:info@amiphotovideo.com" className="text-foreground underline underline-offset-4" data-testid="privacy-contact-email">info@amiphotovideo.com</a>
        </p>
      </div>
    </div>
  );
};

export default Privacy;
